import Home from '../views/Home';
// const Login = () => import(/* webpackChunkName: "auth" */ '../views/auth/Login')
// const Register = () =>
//   import(/* webpackChunkName: "auth" */ '../views/auth/Register')
// const PasswordReset = () =>
//   import(/* webpackChunkName: "auth" */ '../views/auth/password/Reset')
// const PasswordEmail = () =>
//   import(/* webpackChunkName: "auth" */ '../views/auth/password/Email')

// function loadView(view) {
//   return () =>
//     import(/* webpackChunkName: "view-[request]" */ `../views/${view}.vue`)
// }
import Login from '../views/auth/Login';
import Register from '../views/auth/Register';
import PasswordReset from '../views/auth/password/Reset';
import PasswordEmail from '../views/auth/password/Email';
import Blog from '../views/Blog';
import Post from '../views/Post';
import Buyers from '../views/Buyers';
import Sellers from '../views/Sellers';
import Resources from '../views/Resources';
import Results from '../views/Results';
import About from '../views/About';
import AboutLasvegas from '../views/AboutLasVegas';
import Testimonials from '../views/Testimonials';
import Contact from '../views/Contact';
import Listings from '../views/Listings';
import Listing from '../views/Listing';
import Sold from '../views/Sold';
// import Search from '../views/Search'
// import Favorites from '../views/Favorites';
import CommunitySearch from '../views/search/CommunitySearch';
import NotFound from '../views/404';
import Agents from '../views/Agents';
import PhilipRoy from '../views/PhilipRoy';

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/home',
    redirect: { name: 'home' },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
  },
  {
    path: '/password/reset',
    name: 'password.request',
    component: PasswordEmail,
  },
  {
    path: '/password/reset/:access_token',
    name: 'password.reset',
    component: PasswordReset,
  },
  {
    path: '/blog',
    name: 'blog',
    component: Blog,
    // component: loadView('Blog'),
  },
  {
    path: '/blog/:slug',
    name: 'post',
    component: Post,
    // component: loadView('Post'),
    props: true,
  },
  {
    path: '/listings',
    name: 'listings',
    component: Listings,
    // component: loadView('Listings'),
  },
  {
    path: '/listings/:slug',
    name: 'listing',
    component: Listing,
    // component: loadView('Listing'),
  },
  {
    path: '/mls-listing/:mlsId',
    name: 'mls-listing',
    component: Listing,
    // component: loadView('Listing'),
  },
  {
    path: '/sold',
    name: 'sold',
    component: Sold,
    // component: loadView('Sold'),
  },
  {
    path: '/buyers',
    name: 'buyers',
    component: Buyers,
    // component: loadView('Buyers'),
  },
  {
    path: '/sellers',
    name: 'sellers',
    component: Sellers,
    // component: loadView('Resources'),
  },
  {
    path: '/resources',
    name: 'resources',
    component: Resources,
    // component: loadView('Resources'),
  },
  {
    path: '/results',
    name: 'results',
    component: Results,
    // component: loadView('Results'),
  },
  {
    path: '/testimonials',
    name: 'testimonials',
    component: Testimonials,
    // component: loadView('Testimonials'),
  },
  {
    path: '/agents',
    name: 'agents',
    component: Agents,
    // component: loadView('Agents'),
  },
  {
    path: '/philip-roy',
    name: 'philip-roy',
    component: PhilipRoy,
    // component: loadView('PhilipRoy'),
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: About,
    // component: loadView('About'),
  },
  {
    path: '/about-lv',
    name: 'about-lv',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AboutLasvegas,
    // component: loadView('AboutLasvegas'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    // component: loadView('Contact'),
  },
  // {
  //   path: '/search',
  //   name: 'search',
  //   component: Search,
  // component: loadView('Search'),
  // },
  {
    path: '/search/:community',
    name: 'community-search',
    component: CommunitySearch,
    // component: loadView('CommunitySearch'),
  },
  // {
  //   path: '/favorites',
  //   name: 'favorites',
  //   component: Favorites,
  //   // component: loadView('Favorites'),
  // },
  {
    path: '/404',
    name: '404',
    component: NotFound,
    // component: loadView('404'),
  },
  {
    path: '*',
    redirect: { name: '404' },
  },
];

export default routes;
